import { render, staticRenderFns } from "./EstablishmentViewContacts.vue?vue&type=template&id=4983dc90"
import script from "./EstablishmentViewContacts.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports